import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function PricingSection() {
  const features = ['Bespoke label design service', 'Full wine selection access — reds, whites, rosé & sparkling', 'Premium textured paper & foil options', 'Custom packaging options', 'Dedicated design consultant', 'Event coordination support', 'Delivery included'];
  return <section id="pricing" className="py-24 bg-cream" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-200">
          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-201">
            Pricing
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6" data-id="element-202">
            Tailored to{' '}
            <span className="italic text-wine font-normal" data-id="element-203">Your Needs</span>
          </h2>
          <p className="text-lg text-brown/70" data-id="element-204">
            Every project is unique. Pricing is based on your wine selection,
            quantity, and label design — so you only pay for what you need.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="max-w-lg mx-auto" data-id="element-205">
          <div className="relative bg-white rounded-sm ring-2 ring-wine shadow-xl p-10" data-id="element-206">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-wine text-white text-xs font-bold uppercase tracking-wider py-1 px-4 rounded-full shadow-md" data-id="element-207">
              Bespoke Service
            </div>

            <div className="text-center mb-8" data-id="element-208">
              <h3 className="font-playfair text-3xl font-bold text-charcoal mb-2" data-id="element-209">
                Custom
              </h3>
              <p className="text-brown/60 text-sm" data-id="element-210">
                Tailored solutions for every occasion — from intimate gatherings
                to large-scale events.
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-211">
              <div className="flex items-baseline justify-center text-charcoal" data-id="element-212">
                <span className="text-4xl font-bold font-playfair" data-id="element-213">
                  Quote-Based
                </span>
              </div>
              <div className="text-sm font-medium text-wine mt-3 bg-wine/5 inline-block px-4 py-1.5 rounded-sm" data-id="element-214">
                Based on quantity & wine selection
              </div>
            </div>

            <div className="w-full h-px bg-cream-200 mb-8" data-id="element-215"></div>

            <ul className="space-y-4 mb-10" data-id="element-216">
              {features.map((feature, fIndex) => <li key={fIndex} className="flex items-start" data-id="element-217">
                  <CheckIcon className="w-5 h-5 mr-3 flex-shrink-0 text-wine" data-id="element-218" />
                  <span className="text-brown/80 text-sm" data-id="element-219">{feature}</span>
                </li>)}
            </ul>

            <a href="/design#quote" className="block w-full py-3.5 px-4 rounded-sm font-medium transition-colors duration-300 bg-wine text-white hover:bg-wine-700 text-center" data-id="element-220">
              Request a Quote
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}